<template>
  <section class="time-range-picker">
    <rich-button :icon="startTime&& endTime ? '': 'richic-add'" light @click="addSegmentTime">
      {{ `${startTime || '00:00'} ~ ${endTime || '00:00'}` }}
    </rich-button>
  </section>
</template>

<script>

import {isEmpty, isArray, get} from 'lodash-es'
// 小时 00-23
const HOUR_OPTIONS = (function (count) {
  let i = 0
  let res = []
  while (i < count) {
    let val = i < 10
      ? `0${i}`
      : `${i}`
    res.push({
      text: val,
      value: val
    })
    i++
  }
  return res
})(24)
// 分钟step=10 00-50
const MINUTES_OPTIONS = (function (count) {
  let i = 0
  let res = []
  while (i <= count) {
    let val = i < 10
      ? `0${i}`
      : `${i}`
    res.push({
      text: val,
      value: val
    })
    i += 1
  }
  return res
})(59)
export default {
  props: {
    value: {
      type: [Object, Array, String],
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      startTime: '',
      endTime: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newValue) {
        if (!isEmpty(newValue)) {
          if (isArray(newValue)) {
            this.startTime = newValue[0]
            this.endTime = newValue[1]
          } else {
            this.startTime = get(newValue, 'startTime')
            this.endTime = get(newValue, 'endTime')
          }
        }
      }
    }
  },
  methods: {
    addSegmentTime () {
      // http://rlab-fe.xiaojukeji.com/rich-ui/#/zh-CN/docs/segment-picker
      let segmentData = [
        {
          is: 'rich-picker',
          title: this.gettext('开始时间'),
          data: [HOUR_OPTIONS, MINUTES_OPTIONS]
        },
        {
          is: 'rich-picker',
          title: this.gettext('结束时间'),
          data: [HOUR_OPTIONS, MINUTES_OPTIONS]
        }
      ]
      this.$createSegmentPicker({
        data: segmentData,
        onSelect: (selectedDates, selectedVals, selectedTexts) => {
          let [start, end] = selectedDates
          const [startHour, startMin] = start
          const [endHour, endMin] = end
          if (+startHour > +endHour || (+startHour === +endHour && +startMin > +endMin)) {
            start = [endHour, endMin]
            end = [startHour, startMin]
          }
          this.startTime = start.join(':')
          this.endTime = end.join(':')
          this.$emit('input', [this.startTime, this.endTime])
        },
        onNext: (i, selectedDate, selectedValue, selectedText) => {}
      }).show()
    }
  }
}
</script>

<style lang="scss" scoped></style>
